import { render, staticRenderFns } from "./HomeApp.vue?vue&type=template&id=0a82bba4&scoped=true"
import script from "./HomeApp.vue?vue&type=script&lang=js"
export * from "./HomeApp.vue?vue&type=script&lang=js"
import style0 from "./HomeApp.vue?vue&type=style&index=0&id=0a82bba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82bba4",
  null
  
)

export default component.exports